import React, {useState, useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import isEmail from 'validator/lib/isEmail';
import CartInputField from './Cart/CartInputField';

function NewsletterPopup (props) {
  const [FormEmail, setFormEmail] = useState(props.userEmail);
  const [PrivacyOption, setPrivacyOption] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [NetError, setNetError] = useState(null);
  const [ErrorList, setErrorList] = useState([]);
  const [Message, setMessage] = useState("");

  useEffect(() => {
    setMessage("");    
  }, [FormEmail, PrivacyOption]);


  function requestHandler() {
    var errList = [];

    if ((FormEmail.trim().length === 0) || (!isEmail(FormEmail)) )
      errList.push({id: "Email", msg: "Inserire un indirizo di email valido."});
    if (props.userEmail.length <=3 && PrivacyOption !== true)
      errList.push({id: "CkPrivacy", msg: "E' necessario accettare la privacy policy per proseguire."});

    setErrorList(errList);
    //console.log(errList);
  
    if (errList.length > 0) {
      setMessage("La compilazione dei dati è errata. Segui le indicazioni e riprova!");
      return;
    } else {
      setMessage("");
    }
    let params = [
        {name: "id_e_products", value: props.itemId},
        {name: "id_sessione", value: props.sessionKey},
        {name: "mail", value: FormEmail},
        {name: "id_e_models", value: 0},
      ];   
      props.wsCall(
        "https://ws.mediatoys.it/product/productNotify",
        IsLoading,
        setIsLoading,
        NetError,
        (message) => {
          if (message) {
            const myArr = message.split(" ");
            if (myArr[myArr.length - 1] === "400") {
              // duplicated email error => ignore it
              setMessage("Invio della richiesta di notifica avvenuta con successo.");
            } else 
              setNetError(message);
          }
        },
        params,
        (respData) => {
          console.log(respData);
          let txt = "Invio della richiesta di notifica avvenuta con successo. ";
          if (props.userEmail.length <= 3)
            txt += "Ti abbiamo inviato una e-mail contenente i tuoi dati di accesso. ";
          txt += "Riceverai una e-mail quando il prodotto tornerà disponibile. ";
          setMessage(txt);
        }
      );  
  }

  //console.log(props);
  //console.log(Message);
  //console.log(ErrorList);
  return (
    <Dialog open={true}>
      <DialogTitle>
        {(Message.length === 0 || ErrorList.length > 0) && NetError === null?
          <>Vuoi essere avvisato quando l'articolo tornerà disponibile?</>
          : Message.length > 0? 
            <>Richiesta inoltrata</>
            :
            <>Errore</>
        }
      </DialogTitle>

      <DialogContent>
        {props.userEmail.length > 3 ? (
          <>
            <p>
              Riceverai la segnalazione al tuo indirizzo di e-mail registrato:
            </p>
            <p>
              <b>{props.userEmail}</b>
            </p>
          </>
        ) : (
          <>
            <p>Inserisci il tuo indirizzo e-mail nel campo sottostante.</p>

            <CartInputField
              required={true}
              type="text"
              lbl=""
              name="Email"
              placeholder="E-mail"
              value={FormEmail}
              change={setFormEmail}
              cssClass="riga_info_cart"
              errList={ErrorList}
            />
          </>
        )}

        {props.userEmail.length <= 3 && (Message.length === 0 || ErrorList.length > 0) ? (
          <CartInputField
            required={true}
            type="checkbox"
            lbl="Ho preso visione e accetto l'informativa sulla Privacy"
            name="CkPrivacy"
            value={PrivacyOption}
            change={setPrivacyOption}
            cssClass="privacy_cart"
            labelRight={true}
            //url="/privacy"
            url={props.privacyUrl}
            urlText="leggi"
            errList={ErrorList}
          />
        ) : null}
        {Message.length > 0 ? <p>{Message}</p> : null}
        {Message.length === 0 || ErrorList.length > 0 ? (
          <div
            className="accedi_popup_button"
            onClick={() => requestHandler()}
          >
            Invia
          </div>
        ) : null}
        <div
          className="chiudi_popup_button"
          onClick={() => props.closeHandler()}
        >
          Chiudi
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default NewsletterPopup;